import React from 'react';

const Spacing = ({ lg, md }) => {
  return (
    <div className={`st-height-b${lg} st-height-lg-b${md}`} />
  )
}

export default Spacing;
